// WARNING: every change in this file (and used files) should also be taken into account in the static version that is served at /static/header
import React, { useCallback, useState, MouseEvent } from 'react'
import cx from 'classnames'
import { useIntl } from '@shared/universal/utils/intl'
import { ASSET_HOST } from 'consts/server'

import { Bars } from '../SVGs/Bars'
import { selectCurrentDomain } from '../../stores/selectors'
import { messages } from '../../messages'

import { LanguageSettingsModal } from './LanguageSettingsModal'
import { Navigation } from './Navigation/Navigation'
import { NavigationMobile } from './Navigation/NavigationMobile'
import { SiteSettings } from './SiteSettings'

export const Header = () => {
  const currentDomain = selectCurrentDomain()
  const format = useIntl()

  const [isMobileNavbarOpen, setIsMobileNavbarOpen] = useState(false)
  const [isMobileLangSettingsOpen, setIsMobileLangSettingsOpen] =
    useState(false)
  const handleMobileNavbarToggle = useCallback(
    (ev: MouseEvent) => {
      ev.preventDefault()
      setIsMobileNavbarOpen(open => !open)
    },
    [setIsMobileNavbarOpen],
  )
  const handleMobileLangSettingsToggle = useCallback((ev: MouseEvent) => {
    ev.preventDefault()
    setIsMobileLangSettingsOpen(open => !open)
  }, [])
  const handleClose = useCallback(() => {
    setIsMobileLangSettingsOpen(false)
  }, [])

  const domainPrefixIndex = currentDomain.title.indexOf('.')
  const boldTitle = currentDomain.title.slice(0, domainPrefixIndex)
  const normalTitle = currentDomain.title.slice(domainPrefixIndex)

  return (
    <>
      <header className='header-bg-white'>
        <div className='header-container header-flex'>
          <div className='header__left_wrapper header-w-full'>
            <a
              id='SiteLogo'
              href='/'
              title={currentDomain.description}
              className='header__logo'
            >
              <img
                src={`${ASSET_HOST}/pics-uk/logo-orange.png`}
                alt={currentDomain.title}
              />
              <div
                id='wl-spainholiday-header-navbar-title'
                className={cx(
                  'header-flex header__logo_text_wrapper',
                  isMobileNavbarOpen && 'header-hidden',
                )}
              >
                <span className='header__logo_text'>
                  <span className='header-whitespace-nowrap'>
                    <strong>{boldTitle}</strong>
                    <span>{normalTitle}</span>
                  </span>
                </span>
                <span className='header__logo_text--small header-text-black-ultra'>
                  {format(messages.LOGO_IN_COOPERATION_WITH)}{' '}
                  <span style={{ color: '#0C6EEF' }}>holidu</span>
                </span>
              </div>
            </a>
            <div className='header__buttons_wrapper'>
              <button
                type='button'
                id='wl-spainholiday-header-lang-settings-modal-toggle'
                className={cx(
                  'header__lang_settings_button header-text-black-ultra',
                  !isMobileNavbarOpen && 'header-hidden',
                )}
                onClick={handleMobileLangSettingsToggle}
              >
                <img
                  alt=''
                  className='header-mr-2'
                  src={`${process.env.PUBLIC_PATH}assets/images/flags/${currentDomain.languageCode}.jpg`}
                />
              </button>
              <LanguageSettingsModal
                isOpen={isMobileLangSettingsOpen}
                onClose={handleClose}
              />
              <button
                type='button'
                id='wl-spainholiday-header-navigation-mobile-toggle'
                className='header__lang_settings_button'
                onClick={handleMobileNavbarToggle}
              >
                <Bars className='header-w-7 header-h-7' />
              </button>
            </div>
          </div>
          <div className='header__right_wrapper'>
            <Navigation />
            <SiteSettings />
          </div>
        </div>
      </header>
      <NavigationMobile isOpen={isMobileNavbarOpen} />
    </>
  )
}
